import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class CredentialTypeAttributeTypeMapService extends BaseApiService {

    public getCredentialTypeEndorsementMaps() {
        return this.get('Driver/CredentialTypeAttributeTypeMap/CredentialTypeEndorsementMaps');
    }
    public getCredentialTypeAttributeMaps() {
        return this.get('Driver/CredentialTypeAttributeTypeMap');
    }
}
